module.exports = __webpack_public_path__ + "img/ic_schcool.9cf69ebd.png";